<template>
  <v-dialog v-model="dialog" persistent max-width="400px">
    <v-card>
      <v-toolbar color="#313a46">
        <v-card-title class="text-h5 white--text">{{ labelBtn }} NCM</v-card-title>
      </v-toolbar>
      <v-card-text>
        <v-container>
          <v-form ref="form">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="itensForm.codigo_ncm"
                  label="Código NCM"
                  :rules="[rules.required]"
                  required
                  :disabled="labelBtn == 'Editar'"
                ></v-text-field>
              </v-col>
              <v-col class="d-flex" cols="12" sm="12">
                <v-select
                  :items="schemas"
                  v-model="itensForm.schema"
                  label="Schema"
                  dense
                  :rules="[rules.required]"
                  required
                  :disabled="labelBtn == 'Editar'"
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-row>
                  <v-col class="d-flex" cols="12" sm="12">
                    <v-autocomplete
                      :items="contasContabeis"
                      item-text="text"
                      item-value="value"
                      :value-comparator="comparator"
                      v-model="itensForm.id_contabil"
                      label="Conta Contabil"
                      dense
                      :rules="[rules.required]"
                      required
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-col>
              <v-col class="d-flex" cols="12" sm="12">
                <v-select
                  :items="status"
                  v-model="itensForm.status"
                  label="Status"
                  dense
                  :rules="[rules.required]"
                  required
                ></v-select>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn outlined class="white--text btn-form" color="error" @click="closeModal()"
          >FECHAR</v-btn
        >
        <v-btn
          class="white--text mr-5 btn-form"
          :color="labelBtn == 'Cadastrar' ? '#313a46' : 'warning'"
          @click="labelBtn == 'Cadastrar' ? createNcm() : updateNcm()"
          >{{ labelBtn }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import toast from "@/commom/toast";
import comparator from "@/mixins/comparatorValue";
import contaContabil from "@/services/http/nfeNcm/ContaContabil";
import Contabilizar from "@/services/http/nfeNcm/Contabilizar";

export default {
  mixins: [comparator],

  props: {
    labelBtn: {
      type: String,
    },
    dialog: {
      type: Boolean,
      default: false,
    },
    selectedItem: {
      type: Object,
    },
  },
  data() {
    return {
      ItemSelecionado: "",
      cidade_id: [],
      itensForm: {
        status: { text: "Ativo", value: true },
      },
      contasContabeis: [],
      rules: {
        required: (value) => !!value || "Campo obrigatório.",
        specialChar: (value) =>
          !/[^a-z\d]+/i.test(value) ||
          "O campo não permite caracteres especiais",
      },
      schemas: [
        { text: "CCV", value: "CCV" },
        { text: "NBS", value: "NBS" },
      ],
      // status: [
      //   { value: "0", text: "DESATIVADO" },
      //   { value: "1", text: "ATIVO" },
      //   { value: "2", text: "NÃO VALIDADO" },
      // ],
      status: [
        { value: "0", text: "Sem conta" },
        { value: "1", text: "Validado" },
        { value: "2", text: "Não Validado" },
      ],
    };
  },

  watch: {
    selectedItem(value) {
      this.itensForm.codigo_ncm = value.nfe_ncm;
      this.itensForm.id_contabil = value.cod_contabil;
      this.itensForm.schema = {
        text: value.schema_nbs,
        value: value.schema_nbs,
      };
      this.itensForm.status = value.status;
    },
  },

  created() {
    this.fetchContaContabil();
  },

  methods: {
    closeModal() {
      this.$emit("update:dialog", false);
    },
    async fetchContaContabil() {
      try {
        const { data } = await contaContabil().show({ per_page: -1 });
        this.contasContabeis = data.data.map((conta) => ({
          value: conta.id_contabil,
          text: conta.id_contabil + " - " + conta.conta_contabil,
        }));
      } catch (e) {
        console.log(e);
      }
    },
    async createNcm() {
      if (this.$refs.form.validate()) {
        try {
          await Contabilizar().store(this.itensForm);
          toast("success", "Cadastrado com sucesso");
        } catch (e) {
          toast("error", e.message);
        } finally {
          this.closeModal();
          await this.$parent.fetchContabilizar();
        }
      }
    },
    async updateNcm() {
      if (this.$refs.form.validate()) {
        try {
          let aux = this.itensForm;

          if (aux.id_contabil === "NÃO INFORMADO") delete aux.id_contabil;
          await Contabilizar(this.selectedItem.id_contabilizacao_ncm).update({
            ...aux,
            schema: this.itensForm.schema.value,
          });
          toast("success", "Alterado com sucesso");
        } catch (e) {
          toast("error", e.message);
        } finally {
          this.closeModal();
          this.$emit("onUpdateEnd");
        }
      }
    },
  },
};
</script>
